import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { Form } from 'components/atoms/form';
import { Table } from 'components/molecules/table';
import { BodyShort01, Caption01 } from 'components/styles';
import { ProductiveHeading01, ProductiveHeading02 } from 'ozone/atoms';

export const Section = styled.div`
  padding: var(--spacing-04) 0;

  & > * {
    margin-bottom: var(--layout-03);

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Divider = styled.div`
  border-top: 1px dashed var(--border-color);
  margin: var(--layout-01) 0;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const NotfiyTitle = styled(ProductiveHeading01)`
  color: var(--gray-70);
`;

export const Helper = styled.div`
  ${Caption01};
  color: var(--gray-60);
  margin-bottom: var(--spacing-03);
`;

export const Title = styled(ProductiveHeading02)`
  padding-bottom: var(--spacing-03);
`;

export const Description = styled.div`
  ${BodyShort01};
  color: var(--gray-70);
  margin-top: var(--spacing-02);
  margin-bottom: var(--spacing-05);
`;

export const AlertTable = styled(Table)`
  margin: 0 0 var(--spacing-06);

  td.ant-table-cell {
    padding: 0 var(--spacing-05);
  }

  .ant-table-cell {
    background-color: transparent;
    height: var(--spacing-09);
  }

  .ant-table-row {
    padding: 0;
    &:hover {
      > td {
        background-color: var(--table-row-hover) !important;
      }
    }
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: 0;
  }
`;

export const UpdateIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: var(--spacing-03);
  gap: var(--spacing-02);
`;

export const TableHeader = styled.div`
  height: var(--spacing-08);
  display: flex;
  padding: var(--spacing-03) var(--spacing-05);
  align-items: center;
  justify-content: space-between;
  background-color: var(--coolest-gray-10);
  margin-bottom: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing-03);
`;

export const UsersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const CurrencySelectWrapper = styled.div`
  width: 324px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: var(--spacing-05);

  ${Button} {
    flex: 1;
  }
`;

export const Spacer = styled.div`
  margin-bottom: var(--spacing-04);
`;

export const StyledCheckBox = styled(Checkbox)`
  display: flex;
  align-items: center;
  .ant-checkbox-wrapper {
    padding-bottom: var(--spacing-06) !important;
  }
`;

export const AlertHeader = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const AlertTitle = styled(UpdateIconsWrapper)`
  gap: var(--spacing-03);
  color: var(--gray-80);
  font-size: var(--font-size-sm);
`;

const ActionIconBase = css`
  padding: var(--spacing-03);
  &:hover {
    background-color: var(--coolest-gray-20);
  }
`;

export const EditIcon = styled.div`
  ${ActionIconBase};
  &:hover {
    color: var(--blue-60);
  }
`;

export const DeleteIcon = styled.div`
  ${ActionIconBase};
  &:hover {
    color: var(--red-60);
  }
`;

export const EmptyStateWrapper = styled.div`
  color: var(--gray-40);
`;

export const AlertInfoWrapper = styled.div`
  color: var(--gray-70);
`;

export const InfoWrapper = styled.div`
  max-width: 60%;
  min-width: 600px;
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: var(--spacing-04);
`;
